(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-validate/assets/javascript/router.js') >= 0) return;  svs.modules.push('/modules/tickets-validate/assets/javascript/router.js');
"use strict";


svs.ticketsValidate.logger = svs.core.log.getLogger('tickets-validate');
const {
  PlayerRouter,
  Route,
  Switch
} = svs.app.ReactRouter;
const {
  useRouteMatch
} = ReactRouterDOM;
const {
  baseUrl
} = svs.core.data;
const {
  VALIDATE,
  VALIDATED,
  LANDING,
  VALIDATED_BUY_NEW,
  VALIDATED_BUY_NEW_DEFAULT,
  ROOT
} = svs.ticketsValidate.routes;
const {
  Validate,
  Validated,
  Landing,
  ValidatedBuyNew,
  Root
} = svs.ticketsValidate.pages;
const {
  ScrollToTop,
  InstructionsInfo
} = svs.ticketsValidate.components;
const {
  ValidateProvider
} = svs.ticketsValidate.components.context;
const NavigationBack = svs.tur.NavigationBack;
const branding = svs.tickets.data.templateConfig.branding === 'triss' ? 'triss' : 'skrapspel';
const routes = {
  [VALIDATED_BUY_NEW]: {
    text: 'Välj vinstutbetalning',
    path: () => location.pathname.replace('/kop-nya', '')
  }
};
const Instructions = () => {
  const landingMatch = useRouteMatch(LANDING);
  const validateMatch = useRouteMatch(VALIDATE);
  if (!landingMatch && !validateMatch) return null;
  return React.createElement(InstructionsInfo, {
    showStepByStep: landingMatch.isExact || validateMatch.isExact
  });
};
const Router = () => React.createElement(PlayerRouter, {
  basename: baseUrl,
  withRouter: true
}, React.createElement(ValidateProvider, null, React.createElement(ScrollToTop, null), React.createElement(NavigationBack, {
  brand: branding,
  routes: routes
}), React.createElement(Switch, null, React.createElement(Route, {
  component: Root,
  exact: true,
  path: ROOT
}), React.createElement(Route, {
  component: ValidatedBuyNew,
  exact: true,
  path: VALIDATED_BUY_NEW
}), React.createElement(Route, {
  component: ValidatedBuyNew,
  exact: true,
  path: VALIDATED_BUY_NEW_DEFAULT
}), React.createElement(Route, {
  component: Landing,
  exact: true,
  path: LANDING
}), React.createElement(Route, {
  component: Validate,
  exact: true,
  path: VALIDATE
}), React.createElement(Route, {
  component: Validated,
  exact: true,
  path: VALIDATED
})), React.createElement(Instructions, null)));
const container = document.getElementById('reactContainer');
container && ReactDOM.render(React.createElement(Router, null), container);

 })(window);